(function (angular, app) {
   "use strict";
    
   // Slider
   angular.module(app.modules.ui.name)
      .directive(app.modules.ui.directives.datepicker, DatePickerDirective);
      
   DatePickerDirective.$inject = ["$timeout"
        , app.modules.common.constants.calendarlist
        , app.modules.common.services.functions
   ];
   
   function DatePickerDirective($timeout
       , ggCalendar
       , ggFunctions
       ) {
      
       var ctrl = this;
       var date = new Date();
      
      return {
         restrict : "A"
         , templateUrl : "app/ui/directives/datepicker.html"
         , scope: {
            callback : "&"
         }
         , link : function (scope, element, attrs) {
            var base = {
               month: "0"
               , day: "1"
               , year: date.getFullYear()
            }
            scope.dp = {

               calendar: ggCalendar
               , current: {
                  month: base.month // 0 Based Index
                  , day: base.day // 1 Based Number
                  , year: base.year
                  , allowNull: false
                  , picktype: "future"
                  , currentDate: null
                  , days: []
                  , years: []
               }
               , f: {
                  getDateObject: function (d) {
                     var dateObject = {
                        month: null
                        , day: null
                        , year: null
                     }
                     var ds = "";
                     if (!d) {
                        d = "";
                     }

                     var cd = new Date(d);
                     if (cd == "Invalid Date") {
                        d = "";
                     }

                     ds = ggFunctions.formatDateString(d, "yyyy-mm-dd", null)

                     dateObject.date = ds;
                     dateObject.year = Number(ds.substr(0, 4));
                     dateObject.month = Number(ds.substr(5, 2)) - 1;
                     dateObject.day = Number(ds.substr(8, 2));

                     return dateObject;
                  }
                  , getDayCount: function (m, y) {
                     if (m == -1) {
                        // default 31 days.
                        return 31;
                     } else {
                        // check month for days
                        var dc = scope.dp.calendar[m].days;
                        if (m == 1) { // February Leap Year
                           for (var x = 1904; x < 2041;) {
                              if (y == x) {
                                 dc = 29;
                              }
                              x = x + 4;
                           }
                        }
                        return dc;
                     }
                  }
                  , setDayList: function (m, y) {
                     var dc = scope.dp.f.getDayCount(m, y);
                     scope.dp.current.days = [];
                     for (var d = 1; d < dc + 1; d++) {
                        scope.dp.current.days[d - 1] = d;
                     }
                  }
                  , setYearList: function () {

                     var y = Number(base.year);

                     scope.dp.current.years = [];
                     if (scope.dp.current.picktype == "past") {
                        // History
                        var z = 0;
                        for (var x = 0; x > -120; x--) {
                           scope.dp.current.years[z] = y + x;
                           z++;
                        }
                     } else {
                        // Future
                        for (var x = 0; x < 10; x++) {
                           scope.dp.current.years[x] = y + x;
                        }

                     }

                  }
                  , getMonthName: function (index) {
                     if (index > -1) {
                        return scope.dp.calendar[index].abbr;
                     } else {
                        return "---";
                     }

                  }
                  , getDayName: function (day) {

                     if (day > 0) {
                        var d = day + "";
                        if (day < 10) {
                           d = "0" + day;
                        }
                        return d;
                     } else {
                        return "---";
                     }
                  }
                  , getYearName: function (year) {
                     if (year.toSting == "0") {
                        return "---"
                     } else {
                        return year;
                     }

                  }
                  , getWeekDayName: function (day, month, year) {

                     if (day > 0 && month > -1 && year > 0) {
                        var d = (month + 1) + "/" + day + "/" + year;
                        var nd = new Date(d)
                        var wd = nd.getDay();

                        switch (wd) {
                           case 0:
                              return "Sun";
                              break;
                           case 1:
                              return "Mon";
                              break;
                           case 2:
                              return "Tue";
                              break;
                           case 3:
                              return "Wed";
                              break;
                           case 4:
                              return "Thu";
                              break;
                           case 5:
                              return "Fri";
                              break;
                           case 6:
                              return "Sat";
                              break;
                        }
                     } else {
                        return "";
                     }
                  }
                  , selectMonth: function () {
                     var dc = scope.dp.f.getDayCount(scope.dp.current.month, scope.dp.current.year);
                     if (dc < scope.dp.current.day) {
                        scope.dp.current.day = dc;
                     }
                     scope.dp.f.setDayList(scope.dp.current.month, scope.dp.current.year);
                     scope.dp.f.dateIsChanged();
                  }
                  , selectDay: function () {
                     scope.dp.f.dateIsChanged();
                  }
                  , selectYear: function () {
                     scope.dp.f.setDayList(scope.dp.current.month, scope.dp.current.year);
                     scope.dp.f.dateIsChanged();
                  }
                  , isMonthSelected: function (m) {
                     return m == scope.dp.current.month;
                  }
                  , isDaySelected: function (m) {
                     return m == scope.dp.current.day;
                  }
                  , isYearSelected: function (m) {
                     return m == scope.dp.current.year;
                  }
                  , dateIsChanged: function () {
                     var dateObj = {};
                     if (Number(scope.dp.current.month) > -1 && Number(scope.dp.current.day) > 0 && Number(scope.dp.current.year) > 0) {
                        var date = (Number(scope.dp.current.month) + 1) + "/" + scope.dp.current.day + "/" + scope.dp.current.year;
                        var dateObj = scope.dp.f.getDateObject(date);

                        scope.dp.current.currentDate = dateObj.date
                     } else {
                        dateObj = {
                           date: null
                        }
                     }

                     // Parent Callback
                     scope.callback()(dateObj);

                  }
               }
            }

            
            var loadOptions = function (objStr, isUpdate) {
               if (objStr) {
                  var obj = JSON.parse(objStr);
                  if (obj) {

                     // Default View
                     if (obj.allowNull) {
                        scope.dp.current.allowNull = obj.allowNull;
                     }

                     if (obj.picktype) {
                        scope.dp.current.picktype = obj.picktype;
                     }

                    
                     if (obj.currentDate || !scope.dp.allowNull) {
                        var dateObj = null;
                        dateObj = scope.dp.f.getDateObject(obj.currentDate);

                        scope.dp.current.currentDate = dateObj.date;
                        scope.dp.current.year = dateObj.year.toString();
                        scope.dp.current.month = dateObj.month.toString();
                        scope.dp.current.day = dateObj.day.toString();

                        scope.dp.f.setDayList(scope.dp.current.month, scope.dp.current.year);
                        scope.dp.f.setYearList();

                     } else {
                        // No Date supplied
                        scope.dp.f.setDayList(-1, base.year);
                        scope.dp.f.setYearList();
                        scope.dp.current.month = "-1";
                        scope.dp.current.year = "0";
                        scope.dp.current.day = "0";
                     }

                     scope.dp.f.dateIsChanged();

                  }
               }
            }

            // Watch for Change in Options
            attrs.$observe('options', function () {
               var optStr = attrs.options;
               if (optStr != "") {
                  loadOptions(optStr, true);
               }
            });

         }
      }
   }
}(angular, app));
